"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromBlankHours = void 0;
function fromBlankHours(utils) {
    var loadPrimaryInput = utils.loadPrimaryInput, clearAllSegments = utils.clearAllSegments, use = utils.use, a11yHasExpectedHtml = utils.a11yHasExpectedHtml, hasReturnVal = utils.hasReturnVal;
    describe('Hours - From blank', function () {
        incrementBlankHours();
        decrementBlankHours();
        function incrementBlankHours() {
            describe('increment blank hours', function () {
                it('Should increment blank hours --:30 PM to 01:30 PM', function () {
                    loadPrimaryInput({ segment: 'hrs12' })
                        .then(use.del)
                        .should('have.value', '--:30 PM')
                        .then(use.upArrow)
                        .should('have.value', '01:30 PM')
                        .then(a11yHasExpectedHtml("<p>1.</p>"))
                        .then(hasReturnVal('13:30'));
                });
                it('Should increment blank hours from --:-- -- to 01:-- --', function () {
                    loadPrimaryInput({ segment: 'hrs12' }).then(function () {
                        return clearAllSegments('hrs12')
                            .then(use.upArrow)
                            .should('have.value', '01:-- --')
                            .then(a11yHasExpectedHtml("<p>1.</p>"))
                            .then(hasReturnVal(''));
                    });
                });
            });
        }
        function decrementBlankHours() {
            describe('decrement blank hours', function () {
                it('Should decrement blank hours --:30 PM to 12:30 PM', function () {
                    loadPrimaryInput({ segment: 'hrs12' })
                        .then(use.del)
                        .should('have.value', '--:30 PM')
                        .then(use.downArrow)
                        .should('have.value', '12:30 PM')
                        .then(a11yHasExpectedHtml("<p>12.</p>"))
                        .then(hasReturnVal('12:30'));
                });
                it('Should decrement blank hours from --:-- -- to 12:-- --', function () {
                    loadPrimaryInput({ segment: 'hrs12' }).then(function () {
                        return clearAllSegments('hrs12')
                            .then(use.downArrow)
                            .should('have.value', '12:-- --')
                            .then(a11yHasExpectedHtml("<p>12.</p>"))
                            .then(hasReturnVal(''));
                    });
                });
            });
        }
    });
}
exports.fromBlankHours = fromBlankHours;
